/* eslint camelcase:0 max-statements: 0 */

export default (values) => {
  const errors = {}
  const { location } = values

  if (!location) {
    errors.location = 'location.required'
  }

  return errors
}
